import type { RectSnapshot } from "../type/tonalTest";

export const toRectSnapshot = (rect: DOMRect): RectSnapshot => ({
  top: rect.top,
  left: rect.left,
  width: rect.width,
  height: rect.height
});

export const getOverlayTargetRect = (): RectSnapshot => {
  const appContent = document.querySelector(".app-content");
  const containerRect = appContent?.getBoundingClientRect();
  const availableWidth = containerRect?.width ?? window.innerWidth;
  const availableHeight = containerRect?.height ?? window.innerHeight;
  const width = Math.min(Math.max(availableWidth - 64, 320), 1120);
  const height = Math.min(Math.max(availableHeight - 64, 320), 680);
  const leftBase = containerRect?.left ?? 0;
  const topBase = containerRect?.top ?? 0;
  return {
    top: topBase + Math.max(32, (availableHeight - height) / 2),
    left: leftBase + (availableWidth - width) / 2,
    width,
    height
  };
};
